import type { ItemSubCategoryResult } from '../data/ItemSubCategoryFragment'
import type { ProductBannerResult } from '../data/ProductFragment'

export const getExcludedAllergens = (allAllergens: ItemSubCategoryResult[], product: ProductBannerResult) => {
	const allergens = product.itemSubCategories.filter((subCategory) => subCategory.isAllergenTag)

	const idsOfProductAllergens = allergens.map(({ id }) => id)

	const restOfAllergens = allAllergens.filter(({ id }) => !idsOfProductAllergens.includes(id))

	return restOfAllergens
}
